import React, { useState, useEffect } from 'react';
//import DatePicker from 'react-datepicker';
import axios from 'axios';
import QRCode from 'qrcode.react';
import paper from '../../../src/assets/images/paper.jpg';
import 'react-datepicker/dist/react-datepicker.css';
import './Nursery.css';
//import ExportDatePicker from "./JalaliDatePicker";
import { DatePicker } from "jalali-react-datepicker";


function Nursery() {
    const iranProvinces = [
        { ID: 1, EnglishName: "Ardabil" },
        { ID: 2, EnglishName: "Isfahan" },
        { ID: 3, EnglishName: "Alborz" },
        { ID: 4, EnglishName: "Ilam" },
        { ID: 5, EnglishName: "East Azerbaijan" },
        { ID: 6, EnglishName: "West Azerbaijan" },
        { ID: 7, EnglishName: "Bushehr" },
        { ID: 8, EnglishName: "Tehran" },
        { ID: 9, EnglishName: "Chaharmahal and Bakhtiari" },
        { ID: 10, EnglishName: "South Khorasan" },
        { ID: 11, EnglishName: "Razavi Khorasan" },
        { ID: 12, EnglishName: "North Khorasan" },
        { ID: 13, EnglishName: "Khuzestan" },
        { ID: 14, EnglishName: "Zanjan" },
        { ID: 15, EnglishName: "Semnan" },
        { ID: 16, EnglishName: "Sistan and Baluchestan" },
        { ID: 17, EnglishName: "Fars" },
        { ID: 18, EnglishName: "Qazvin" },
        { ID: 19, EnglishName: "Qom" },
        { ID: 20, EnglishName: "Kurdistan" },
        { ID: 21, EnglishName: "Kerman" },
        { ID: 22, EnglishName: "Kermanshah" },
        { ID: 23, EnglishName: "Kohgiluyeh and Boyer-Ahmad" },
        { ID: 24, EnglishName: "Golestan" },
        { ID: 25, EnglishName: "Guilan" },
        { ID: 26, EnglishName: "Lorestan" },
        { ID: 27, EnglishName: "Mazandaran" },
        { ID: 28, EnglishName: "Markazi" },
        { ID: 29, EnglishName: "Hormozgan" },
        { ID: 30, EnglishName: "Hamadan" },
        { ID: 31, EnglishName: "Yazd" },
        { ID: 389452, EnglishName: "Mantaghe Jonob Kerman" }
    ];


    const [hasSearchParams, setHasSearchParams] = useState(false);
    const [loading, setLoading] = useState(true);
    const [provinces, setProvinces] = useState(iranProvinces);
    const [result, setResult] = useState({});
    const [attachments, setAttachments] = useState([]);
    const [resultState, setResultState] = useState('none'); // none, loading, notFound, found
    const [date, setDate] = useState(new Date());
    const [place, setPlace] = useState(null);
    const [code, setCode] = useState('');

    useEffect(() => {
        axios
            .post('Place/List', { Type: 2 })
            .then((result) => {
                if (result.data.Success && result.data.Data && result.data.Data.length) {
                    //setProvinces(result.data.Data);
                }

                if (window.location.search) {
                    const params = new URLSearchParams(window.location.search);
                    setCode(params.get('sn'));
                    setPlace(params.get('poi'));
                    setDate(new Date(parseInt(params.get('d'))));
                    setHasSearchParams(true);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);
    useEffect(() => {
        if (hasSearchParams)
            search();
    }, [hasSearchParams]);

    return (
        <div style={{ direction: 'rtl' }}>
            <h2>استعلام گواهی بهداشت اندام های تکثیرشونده گیاهی</h2>

            <fieldset disabled={resultState === 'loading'} style={{ all: 'unset', display: 'block' }}>
                <div className="row">
                    <div className="form-group">
                        <label>شماره مجوز</label>
                        <input type="text" className="form-control" value={code} onChange={e => setCode(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label>محل صدور</label>
                        <select className="form-control" value={place} onChange={e => setPlace(e.target.value)}>
                            {provinces.map(function (p, i) {
                                return (<option key={i} value={p.ID}>{p.EnglishName}</option>);
                            })}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>تاریخ</label>
                        <DatePicker
                            disabled={resultState === 'loading'}
                            timePicker={false}
                            value={date}
                            onClickSubmitButton={(e) => {
                                setDate(e.value._d);
                            }}
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="row button-container">
                    <button type="button" onClick={search}>جستجو</button>
                </div>
            </fieldset>
            <QRCode
                id="qrcode-canvas"
                style={{ display: 'none' }}
                value={`http://ephyto.pms.ppo.ir/nursery?sn=${code}&poi=${place}&d=${date.getTime()}`}
            />
            {resultState !== 'none' && (
                <div className="row result-container">
                    {resultState === 'loading' && <code>در حال جستجو .....</code>}
                    {resultState === 'notFound' && <code>مجوزی با اطلاعات وارد شده یافت نشد</code>}
                    {resultState === 'found' && (
                        <code>
                            مجوز موجود است. <span className="link" onClick={print}>(نمایش مجوز)</span>
                            {attachments.map((attachment, index) => {
                                return (
                                    <p key={index}>
                                        <a href={attachment.filePath} target="_blank">attachment #{index + 1}</a>
                                    </p>
                                );
                            })}
                        </code>
                    )}
                </div>
            )}
            {resultState === 'found' && (
                <div id="print" dir="rtl" style={{ display: 'none', direction: 'rtl' }}>
                    <div id="print-container" className="print-container" dir="rtl">
                        <header>
                            <div className="head-Top">
                                <div className="head-Right">
                                    <div className="head-Right-Title">
                                        <h3>
                                            سازمان حفظ نباتات
                                        </h3>
                                    </div>
                                    <div className="head-Right-Logo">
                                        <img alt="Logo" src="https://pms.ppo.ir/app/assets/NurseryPhyto-Print/NurseryPhyto-Logo.jpg" />
                                    </div>
                                </div>
                                <div className="head-Left">
                                    <p><b>1-</b> شماره گواهی بهداشت نباتی :&nbsp; <b>{result.Number}</b></p>
                                    <p><b>2-</b> تاریخ صدور :&nbsp; <b>{result.LicenceIssueDateJalali}</b></p>
                                    <p><b>3-</b> محل صدور :&nbsp; <b>{result.ProvinceName}</b></p>
                                </div>
                            </div>
                            <div className="head-Bottom">
                                <div style={{ display: 'block', width: 100 + '%' }}>
                                    <p>فرم گواهی بهداشت نباتی &nbsp; <b>{result.BodyTypesName}</b></p>
                                </div>
                                {/*<div className="head-Left">*/}
                                {/*    <p style={{ margin: '2px 0 !important' }}>شماره سریال: {result.SerialNo}</p>*/}
                                {/*</div>*/}
                            </div>
                        </header>
                        <section>
                            <div className="section-Item">
                                <p><b>4-</b> بدین وسیله گواهی میشود : ترخیص و انتقال &nbsp;&nbsp;<b>{result.BodyTypesName}</b>&nbsp;&nbsp; تولیدشده در &nbsp;&nbsp;<b>{result.ProductionPlaceTypeName}</b>&nbsp;&nbsp; بامشخصات ذیل به استان &nbsp;&nbsp;<b>{result.CustomerProvinceName}</b>&nbsp;&nbsp; ،شهرستان &nbsp;&nbsp;<b>{result.CustomerCityName}</b>&nbsp;&nbsp; به آدرس &nbsp;&nbsp;<b>{result.CustomerAddress}</b>&nbsp;&nbsp; خریداری شده توسط &nbsp;&nbsp;<b>{result.CustomerFullName}</b>&nbsp;&nbsp; به شماره تلفن &nbsp;&nbsp;<b>{result.CustomerCellPhone}</b>&nbsp;&nbsp; از نظر مقررات قرنطینه‌ گیاهی بلامانع میباشد.</p>

                                {/*<p>4- بدین وسیله گواهی میشود: ترخیص و انتقال {result.PlantTypesName} تولیدشده در نهالستان/ باغ‌مادری {result.CustomerFullName} با مشخصات ذیل به مقصد {result.CustomerAddress} از نظر مقررات قرنطینه نباتی بلامانع میباشد.</p>*/}
                                <p><b>5-</b> :نوع وسیله نقلیه &nbsp;&nbsp;<b>{result.TruckType}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  شماره پلاک :  &nbsp;&nbsp;<b>{result.TruckNO4Name + ' ایران - ' + result.TruckNO3Name + result.TruckNO2Name + result.TruckNO1Name}</b></p>
                            </div>
                            <div className="section-Item">
                                <p><b>6-</b> مدت اعتبار این گواهی از تاریخ &nbsp;&nbsp;<b>{result.LicenceIssueDateJalali}</b>&nbsp;&nbsp; لغایت &nbsp;&nbsp;<b>{result.LicenceExpireDateJalali}</b>&nbsp;&nbsp; میباشد.</p>
                            </div>
                            <div className="section-Item">
                                <p>
                                    <b>7-</b> نام و نشانی دقیق محل تولید &nbsp;&nbsp;{result.PlantTypesName}
                                </p>
                                <p>استان &nbsp;&nbsp;<b>{result.ProvinceName}</b>&nbsp;&nbsp; ، شهرستان &nbsp;&nbsp;<b>{result.CityName}</b>&nbsp;&nbsp; به آدرس &nbsp;&nbsp;<b>{result.Address}</b></p>
                            </div>
                            <table className="section-Item" style={{ display: 'table' }}>
                                <thead>
                                    <tr>
                                        <th colspan="11"><b>8-</b> مشخصات {result.PlantTypesName} گواهی شده</th>
                                    </tr>
                                    <tr>
                                        <th>ردیف</th>
                                        <th>نوع اندام تکثیری</th>
                                        <th>گروه محصولی</th>
                                        <th>نام محصول</th>
                                        {/*<th>رقم</th>*/}
                                        {/*<th>روش ازدیاد</th>*/}
                                        {/*<th>طبقه تولید</th>*/}
                                        {/*<th>سن</th>*/}
                                        <th>تعداد</th>
                                        <th>واحد</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {result.Details.map((item, index) => {
                                        return (
                                            <tr>
                                                <th>{index + 1}</th>
                                                <td>{item.BodyTypeName}</td>
                                                <td>{item.PlantTypeName}</td>
                                                <td>{item.ProductName}</td>
                                                {/*<td>{ item.SeedlingCultivar }</td>*/}
                                                {/*<td>{ item.PropagationMethodName }</td>*/}
                                                {/*<td>{ item.ClassName }</td>*/}
                                                {/*<td>{ item.AgeTypeName }</td>*/}
                                                <td>{item.Count}</td>
                                                <td>{item.UnitTypeName}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <div className="section-Item">
                                <p><b>9-</b> اقدامات ضدعفونی : مقدار / تعداد &nbsp;&nbsp;<b>{result.ProductsInfo}</b>&nbsp;&nbsp;  با مصرف &nbsp;&nbsp;<b>{result.ChemicalCompositionName}</b>&nbsp;&nbsp; به روش &nbsp;&nbsp;<b>{result.DisinfectionTechniqueName}</b>&nbsp;&nbsp; و به مدت &nbsp;&nbsp;<b>{result.DisinfectionTime}</b>&nbsp;&nbsp; دقیقه ضدعفونی گردیده است.</p>
                                <p>توضیحات فنی :&nbsp;&nbsp; <b>{result.TechnicalComment ? result.TechnicalComment : '***************************'}</b>&nbsp;&nbsp;</p>
                            </div>
                        </section>
                        <footer>
                            <div className="footer-right">
                                <p>10- نام و نام خانوادگی کلینیک بازرسی کننده: &nbsp;&nbsp;{result.ClinicExpertFullName2}</p>
                                <p>11- نام و نام خانوادگی و امضاء مسئول قرنطینه: &nbsp;&nbsp;{result.ProvinceExpertFullName}</p>
                                <p>12- نام و نام خانوادگی و امضاء مدیریت حفظ نباتات استان: &nbsp;&nbsp;{result.ProvinceManagerFullName}</p>
                                <p>خریدار محترم در صورت عدم الصاق لیبل موسسه تحقیقات ثبت و گواهی بذر و نهال به محصولات فوق الذکر این گواهی فاقد اعتبار میباشد.</p>
                            </div>
                            <div class="qr-container">
                                <img id="qrcode-image1" />
                            </div>
                        </footer>
                    </div>
                    <div>
                        {brCounter(result.Details).map((item, index) => {
                            return (
                                <br />
                            );
                        })}
                    </div>
                    <div id="print-container" className="print-container" dir="rtl">
                        <header>
                            <div className="head-Top">
                                <div className="head-Right">
                                    <div className="head-Right-Title">
                                        <h3>
                                            سازمان حفظ نباتات
                                        </h3>
                                    </div>
                                    <div className="head-Right-Logo">
                                        <img alt="Logo" src="https://pms.ppo.ir/app/assets/NurseryPhyto-Print/NurseryPhyto-Logo.jpg" />
                                    </div>
                                </div>
                                <div className="head-Left">
                                    <p><b>1-</b> شماره گواهی بهداشت نباتی :&nbsp; <b>{result.Number}</b></p>
                                    <p><b>2-</b> تاریخ صدور :&nbsp; <b>{result.LicenceIssueDateJalali}</b></p>
                                    <p><b>3-</b> محل صدور :&nbsp; <b>{result.ProvinceName}</b></p>
                                </div>
                            </div>
                            <div className="head-Bottom">
                                <div style={{ display: 'block', width: 100 + '%' }}>
                                    <p>فرم گواهی بهداشت نباتی &nbsp; <b>{result.BodyTypesName}</b></p>
                                </div>
                                {/*<div className="head-Left">*/}
                                {/*    <p style={{ margin: '2px 0 !important' }}>شماره سریال: {result.SerialNo}</p>*/}
                                {/*</div>*/}
                            </div>
                        </header>
                        <section>
                            {/*<table className="section-Item" style={{ display: 'table' }}>*/}
                            {/*    <thead>*/}
                            {/*        <tr>*/}
                            {/*            <th colspan="4">مشخصات عوامل قرنطینه‌ای {result.BodyTypesName} گواهی شده</th>*/}
                            {/*        </tr>*/}
                            {/*        <tr>*/}
                            {/*            <th>ردیف</th>*/}
                            {/*            <th>نام محصول</th>*/}
                            {/*            <th>نام عامل خسارت</th>*/}
                            {/*            <th>وضعیت بهداشت گیاهی در زمان بازرسی</th>*/}
                            {/*        </tr>*/}
                            {/*    </thead>*/}
                            {/*    <tbody>*/}
                            {/*        {result.DamageAgentDetails.map((item, index) => {*/}
                            {/*            return (*/}
                            {/*                <tr>*/}
                            {/*                    <th>{index + 1}</th>*/}
                            {/*                    <th>{item.PhenologyPersianName}</th>*/}
                            {/*                    <th>{item.DamageAgentPersianName}</th>*/}
                            {/*                    <th>عدم مشاهده آلودگی</th>*/}
                            {/*                </tr>*/}
                            {/*            );*/}
                            {/*        })}*/}
                            {/*    </tbody>*/}
                            {/*</table>*/}

                            <div class="section-Item">
                                <p>
                                    با توجه به بازرسی و بررسی های گیاهپزشکی انجام شده توسط کلینیک  &nbsp;<b>{result.ClinicNameFormatted}</b>&nbsp;  و نظر به گزارشات ارائه شده مبنی بر عدم وجود هرگونه آفات و بیماری های گیاهی مشمول مقررات قرنطینه گیاهی کشور "مطابق فهرست عوامل خسارتزای قرنطینه ای کشور در سال &nbsp;<b>{result.Year }</b>&nbsp; ، جابجایی محصولات مندرج در جدول شماره 8 از نظر سازمان حفظ نباتات کشور بلامانع است.
                                </p>
                            </div>

                            <table class="section-Item" style={{ display: 'table' }}>
                                <thead>
                                    <tr>
                                        <th colspan="7">شماره لیبل های الصاق شده به محصولات خریداری شده مندرج در جدول 8 باید در بازه بین شماره های شروع و پایان لیبل ذکر شده برای هر یک از محصولات باشد و در صورت وجود تناقض، این گواهی فاقد اعتبار می باشد.</th>
                                    </tr>
                                    <tr>
                                        <th>ردیف</th>
                                        <th>نام محصول</th>
                                        <th>نوع اندام</th>
                                        <th>شماره لیبل شروع</th>
                                        <th>شماره لیبل پایان</th>
                                        <th>شماره لیبل سال گذشته شروع</th>
                                        <th>شماره لیبل سال گذشته پایان</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {result.LabelingDetails.map((item, index) => {
                                        return (
                                            <tr>
                                                <th>{index + 1}</th>
                                                <th>{item.ProductName}</th>
                                                <th>{item.BodyTypeName}</th>
                                                {item.NoLabel && <th colspan="4">محصول فاقد لیبل میباشد</th>}
                                                {!item.NoLabel && <th>{item.StartLabelNO ? item.StartLabelNO : '-'}</th>}
                                                {!item.NoLabel && <th>{item.EndLabelNO ? item.EndLabelNO : '-'}</th>}
                                                {!item.NoLabel && <th>{item.ContainsLastYearProducts ? item.LastYearStartLabelNO : '-'}</th>}
                                                {!item.NoLabel && <th>{item.ContainsLastYearProducts ? item.LastYearEndLabelNO : '-'}</th>}
                                            </tr>
                                        );
                                    })}

                                </tbody>
                            </table>
                        </section>
                        <footer>
                            <div className="footer-right">
                                <p>10- نام و نام خانوادگی کلینیک بازرسی کننده: &nbsp;&nbsp;{result.ClinicExpertFullName2}</p>
                                <p>11- نام و نام خانوادگی و امضاء مسئول قرنطینه: &nbsp;&nbsp;{result.ProvinceExpertFullName}</p>
                                <p>12- نام و نام خانوادگی و امضاء مدیریت حفظ نباتات استان: &nbsp;&nbsp;{result.ProvinceManagerFullName}</p>
                                <p>خریدار محترم در صورت عدم الصاق لیبل موسسه تحقیقات ثبت و گواهی بذر و نهال به محصولات فوق الذکر این گواهی فاقد اعتبار میباشد.</p>
                            </div>
                            <div class="qr-container">
                                <img id="qrcode-image2" />
                            </div>
                        </footer>
                    </div>
                </div>
            )}
        </div>
    );

    function generateStars(value, len) {
        len = len || 0;
        if (value)
            return new Array(len - value.length < 0 ? 0 : len - value.length).join('*') || '';
        else
            return '';
    }
    function brCounter(details) {
        var result = [];
        if (details.length >= 10) {
            result.push(0);
        } else {
            for (var i = 0; i < 10 - details.length; i++) {
                result.push(i);
            }
        }

        return result;
    }
    function search() {
        setResultState('loading');
        let exists = false;
        axios.post('ENurseryPhyto/Get', {
            Number: code,
            ProvinceID: parseInt(place),
            LicenceIssueDate: date
        }).then((response) => {
            if (response && response.data && response.data.Data) {
                exists = true;
                setResult(response.data.Data);
                return axios.post('Document/GetAttachments', { ObjectID: response.data.Data.ID });
            }
        }).then((response) => {
            if (response && response.data && response.data.Data && response.data.Data.length) {
                response.data.Data.map((item) => {
                    let filePath = window.location.origin;
                    if (filePath === undefined) {
                        filePath = window.location.protocol + '//'
                            + window.location.hostname
                            + (window.location.port ? ':' + window.location.port : '');
                    }
                    filePath += `/Uploads/${item.FileNameWithExtension}`;
                    item.filePath = filePath;
                });

                setAttachments(response.data.Data.filter((attachment) => {
                    return [4, 5].indexOf(attachment.Type) !== -1;
                }));
            }

            if (exists)
                setResultState('found');
            else
                setResultState('notFound');
        });
    }
    function print() {
        var canvas = document.getElementById("qrcode-canvas");
        var img = canvas.toDataURL("image/png");
        document.getElementById('qrcode-image1').src = img;
        document.getElementById('qrcode-image2').src = img;

        const toPrint = document.getElementById('print');
        const popupWin = window.open(
            "",
            "_blank",
            "width=800,height=600,location=no,left=100px"
        );
        popupWin.document.open();
        popupWin.document.dir = "rtl";
        popupWin.document.write(
            "<html><title></title><style>.print-Container{width:100%;overflow:hidden;border:2px solid;margin:2vw auto!important;direction:rtl;padding:0;font-family:'B Yekan'}.head-Bottom,.print-Container .head-Top{text-align:right;line-height:20px!important;font-size:14px!important;font-weight:600!important;margin:2px auto!important}.print-Container span{font-size:13px;font-weight:400;line-height:19px;text-align:right;display:block}.print-Container header{width:100%;overflow:hidden;display:block}.head-Top{display:block;margin:0 auto;padding:0;overflow:hidden;height:15vw!important}.head-Bottom{display:block;margin:0 auto;padding:0;overflow:hidden;border-top:2px solid;border-bottom:2px solid}.head-Right{width:61%;height:99%;float:right;border-left:2px solid;display:flex;align-items:center}.head-Left{width:38%;float:left;text-align:right;display:flex;height:100%!important;flex-direction:column;justify-content:space-evenly}.head-Left p{font-size:14px!important;line-height:25px!important;text-align:right;display:block;margin:7px auto!important;font-weight:400;width:100%!important}.head-Right-Title{width:60%;float:right;text-align:center}.head-Right-Title>h3{text-align:center;justify-content:center;font-size:23px;font-weight:500;line-height:24px}.head-Right-Logo{width:50%;float:left;text-align:center;overflow:hidden;height:102%!important}.head-Right-Logo>img{height:100%}.print-Container section{width:100%;padding:0!important}.section-Item{padding:10px 5px;display:block;border-bottom:2px solid #000}.section-Item p{font-size:15px;line-height:25px!important;font-weight:400;text-align:right;margin:0!important}table{display:table;width:100%}table,td,th,tr{border:2px solid #000;border-collapse:collapse}.print-Container footer{width:100%;padding:10px 0;position:relative}.qr-container{position:absolute;left:10;top:10;width:100px;height:100px;text-align:center;overflow:hidden}.qr-container>img{width:100%;height:100%}.footer-right{width:100%;float:right}.footer-right p{font-size:14px;line-height:23px;font-weight:600;text-align:right}</style></head><body>"
        );
        popupWin.document.write(toPrint.innerHTML);
        popupWin.document.write("</html>");
        popupWin.document.close();
    }

}

export default Nursery;